import React from "react";
import styles from "./FloatingButton.module.scss";

interface Props {
  children: string | JSX.Element;
  className?: string;
  attributes?: React.ButtonHTMLAttributes<HTMLButtonElement>;
  onClick?: React.MouseEventHandler;
}

const FloatingButton = ({ children, attributes = {}, className = "", onClick }: Props): JSX.Element => (
  <button className={`${styles.btn} ${className}`.trim()} {...attributes} onClick={onClick}>
    {children}
  </button>
);

export default FloatingButton;
